var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navleft'),_vm._v(" "),_c('div',{staticStyle:{"height":"50px","width":"50%"}}),_vm._v(" "),_c('div',{staticClass:"framemain"},[_c('iframe',{attrs:{"src":_vm.iframe_right.url,"frameborder":"0","width":"100%","height":"100%"},on:{"onload":function($event){return _vm.cs(this)}}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7acc64d7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/company/index.vue
// module id = null
// module chunks = 